import React, { Dispatch, SetStateAction, useContext } from 'react';
import { Timeslot } from '../Timeslot';
import { PostingPlanMobileNavigation } from '../PostingPlanMobileNavigation';
import { CategoryColor, StartOfWeekFormatSetting, TimeslotDay } from '../../../../models/graphql';
import classes from './PostingPlanListView.module.scss';
import classNames from 'classnames';
import { TimeslotMappedData } from '../PostingPlan.view';
import { OnboardingContext } from '../../../Onboarding/states/OnboardingProvider';
import { OnboardingStaticContent } from '../../../Onboarding/constants/content';

export type PostingPlanListViewViewProps = {
  //
  events: TimeslotMappedData[];
  selectedDay: TimeslotDay;
  setSelectedDay: Dispatch<SetStateAction<TimeslotDay>>;
  startDayOfWeek: StartOfWeekFormatSetting;
};

export const PostingPlanListViewView = (props: PostingPlanListViewViewProps): JSX.Element => {
  const contentClasses = classNames('grid-x', classes.PostingPlanListContentWrapper);
  const { showOnboarding, state: onboardingState } = useContext(OnboardingContext);
  const { version } = onboardingState;
  const disableDelete = OnboardingStaticContent[`v${version}`].disableDelete.timeslots;
  return (
    <>
      <PostingPlanMobileNavigation
        selectedDay={props.selectedDay}
        setSelectedDay={props.setSelectedDay}
        startDayWeek={props.startDayOfWeek}
      />
      <div className={contentClasses}>
        {props.events?.map((event, index) => (
          <div className={'cell margin-bottom-small-8 small-12'} key={index}>
            <Timeslot
              isListView={true}
              id={`${event.id}`}
              name={event.name || ''}
              colour={event.colour || CategoryColor.LIGHT_GREY}
              day={event.day}
              time={event.time}
              hovering={false}
              isDragging={false}
              actions={event.actions}
              timeFormat={event.timeFormat}
              socialProfiles={event.socialProfiles}
              onboardingContent={event.onboardingContent && disableDelete && showOnboarding}
              categoryId={event.categoryId}
            />
          </div>
        ))}
      </div>
    </>
  );
};
